export default function minTranslate() {
  return -this.snapGrid[0];
}


//////////////////
// WEBPACK FOOTER
// /var/www/vhosts/super-x.blog/httpdocs/~/swiper/esm/components/core/translate/minTranslate.js
// module id = 495
// module chunks = 0